export default __webpack_public_path__ + "static/media/emptyCart.cdb5609b.svg";